/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DataExportRoute,
  DataExportRoute$inboundSchema,
} from "./dataexportroute.js";
import { Destination, Destination$inboundSchema } from "./destination.js";

export type ListDataExportsForOrgResult = {
  /**
   * Active data export destinations across the active organization.
   */
  destinations: Array<Destination>;
  /**
   * Active data export routes across the active organization.
   */
  routes: Array<DataExportRoute>;
};

/** @internal */
export const ListDataExportsForOrgResult$inboundSchema: z.ZodMiniType<
  ListDataExportsForOrgResult,
  unknown
> = z.object({
  destinations: z.array(Destination$inboundSchema),
  routes: z.array(DataExportRoute$inboundSchema),
});

export function listDataExportsForOrgResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDataExportsForOrgResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDataExportsForOrgResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDataExportsForOrgResult' from JSON`,
  );
}
